import gql from 'graphql-tag';

export default gql`
  mutation createPortfolio($name: String!) {
    portfolio: createPortfolio(name: $name) {
      id
      name
      active
      isDefault
    }
  }
`;
